import {API_URL, API_URL_STORY, ORDER_API_URL} from '../constants'
import { apiFetch } from './client';



export const stringifyAnalytics3dParameters = (parameters) => {
    const query = [];
    console.log(parameters)
    try {
        Object.keys(parameters)
            .filter((key) => parameters[key])
            .forEach((key) => {
                switch (key) {
                    case 'page': { // @ts-ignore
                        query.push(`${key}=${parameters[key]}`);
                        break;
                    }
                    case 'generationTypeId': { // @ts-ignore
                        query.push(`${key}=${parameters[key]}`);
                        break;
                    }
                    case 'search':{
                        if(parameters[key].length >= 3){
                            // @ts-ignore
                            query.push(`${key}=${parameters[key]}`);
                        }
                        break;
                    }
                    case 'lastEvaluatedKey': {
                        // @ts-ignore
                        query.push(`${key}=${parameters[key]}`);
                        break;
                    }
                    // case 'perPage': {
                    //     // @ts-ignore
                    //     query.push(`limit=${parameters[key]}`);
                    //     break;
                    // }
                    case 'sort': {
                        // @ts-ignore
                        query.push(`sort=${parameters[key]}`);
                        break;
                    }
                    case 'sortDirection': {
                        // @ts-ignore
                        query.push(`sortDirection=${parameters[key]}`);
                        break;
                    }
                    case 'minDate': {
                        // @ts-ignore
                        query.push(`createdAt_min=${parameters[key]}`);
                        break;
                    }
                    case 'maxDate':{
                        // @ts-ignore
                        query.push(`createdAt_max=${parameters[key]}`);
                        break;
                    }
                    case 'orderExist': {
                            // @ts-ignore
                        query.push(`orderExist=true`);
                        break;
                    }
                    case 'toCart': {
                        // @ts-ignore
                        query.push(`toCart=true`);
                        break;
                    }
                    case 'limit':{
                        // @ts-ignore
                        query.push(`limit=${parameters[key]}`);
                        break;
                    }
                    case 'tags':{
                        // @ts-ignore
                        query.push(`tagIds=${parameters[key]}`);
                        break;
                    }
                    case 'template':{
                        // @ts-ignore
                        query.push(`template=${encodeURIComponent(parameters[key])}`);
                        break;
                    }
                    case 'eventId':{
                        // @ts-ignore
                        query.push(`eventId=${encodeURIComponent(parameters[key])}`);
                        break;
                    }
                    case 'tempEventId':{
                        // @ts-ignore
                        query.push(`tempEventId=${encodeURIComponent(parameters[key])}`);
                        break;
                    }
                    case 'customerId':{
                        // @ts-ignore
                        query.push(`customerId=${encodeURIComponent(parameters[key])}`);
                        break;
                    }
                    case 'productIds':{
                        // @ts-ignore
                        query.push(`productIds=${parameters[key]}`);
                        break;
                    }
                    case 'urlPathIds':{
                        // @ts-ignore
                        query.push(`urlPathIds=${parameters[key]}`);
                        break;
                    }
                    case 'orderStatusId':{
                        if(parameters[key].length > 0){
                            // @ts-ignore
                            query.push(`${key}=${parameters[key]}`);
                        }
                        break;
                    }
                    default: {
                        break;
                    }
                }
            });
    } catch (error) {
        console.warn('Looks like something wrong with fetch products url parameters');
    }
    console.log(`${query.join('&')}`, '--------')
    return `${query.join('&')}`;
};


export const getFullAnalytics3d = async (queryParams) => {
    const res = await apiFetch(`${API_URL}/mockup-analytics/events/stats?${stringifyAnalytics3dParameters(queryParams)}`,{
        method: "GET",
        headers: {
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
    // return DampData;
};



export const getMockupAnalytics3d = async (queryParams) => {
    const res = await apiFetch(`https://wsbhutpcl9.execute-api.us-west-1.amazonaws.com/dev/admin-api/mockup/events?${stringifyAnalytics3dParameters(queryParams)}`,{
        method: "GET",
        headers: {
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
    // return DampData;
};

// export const getOrderById = async (data) => {
//     const token = store.getState().auth.data.token;
//     const res = await fetch(`${ORDER_API_URL}/clients/${data.companyId}/orders/${data.id}`,{
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${encodeURIComponent(token)}`
//         },
//     });
//     if (!res.ok) {
//         if(res.status === 401){
//             store.dispatch(logOutUser())
//             throw new Error('Unauthorized!');
//         }
//         throw new Error('Server Error!');
//     }
//     return await res.json();
// };
// export const updateOrderById = async (id, data) => {
//     const token = store.getState().auth.data.token;
//     const res = await fetch(`${ORDER_API_URL}secure/orders/${id}`,{
//         method: "PUT",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${encodeURIComponent(token)}`
//         },
//         body: JSON.stringify({...data})
//     });
//     if (!res.ok) {
//         if(res.status === 401){
//             store.dispatch(logOutUser())
//             throw new Error('Unauthorized!');
//         }
//         throw new Error('Server Error!');
//     }
//     return await res.json();
// };
// export const createOrder = async (data) => {
//     const token = store.getState().auth.data.token;
//     const res = await fetch(`${API_URL}secure/orders`,{
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${encodeURIComponent(token)}`
//         },
//         body: JSON.stringify({...data})
//     });
//     if (!res.ok) {
//         if(res.status === 401){
//             store.dispatch(logOutUser())
//             throw new Error('Unauthorized!');
//         }
//         throw new Error('Server Error!');
//     }
//     return await res.json();
// };


// export const getReportModerator = async ({companyId, queryParams,  onSuccess}) => {
//     const token = store.getState().auth.data.token;
//     const res = await fetch(`${ORDER_API_URL}/clients/${companyId}/reports/orders/prinfile_v1`,{
//         method: "POST",
//         // mode: "no-cors", // no-cors, *cors, same-origin
//         headers: {
//             "Content-Type": "application/json",
//             // 'Content-Type': 'application/x-www-form-urlencoded',
//             // 'Access-Control-Allow-Origin': '*',
//             "Authorization": `Bearer ${encodeURIComponent(token)}`
//         },
//         body:JSON.stringify(queryParams),
//     });
//     if (!res.ok) {
//         if(res.status === 401){
//             store.dispatch(logOutUser())
//             throw new Error('Unauthorized!');
//         }
//         throw new Error('Server Error!');
//     }
//     const rest = await res.json();
//     if (onSuccess) {
//         onSuccess(rest);
//     }
//     return rest;
// };


export const getMockupsData = async (queryParams) => {
    const res = await apiFetch(`${API_URL}/mockup/events?${stringifyAnalytics3dParameters(queryParams)}`,{
        method: "GET",
        headers: {
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
    // return DampData;
};

export const getMockupsStatsData = async (queryParams) => {
    const res = await apiFetch(`${API_URL}/mockup/stats/mockups?${stringifyAnalytics3dParameters(queryParams)}`,{
        method: "GET",
        headers: {
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getMockupsCompareStatsData = async (queryParams) => {
    const res = await apiFetch(`${API_URL}/mockup/stats/compare?${stringifyAnalytics3dParameters(queryParams)}`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};


export const getMockupsCustomersData = async (queryParams) => {
    const res = await apiFetch(`${API_URL}/mockup/customers?${stringifyAnalytics3dParameters(queryParams)}`,{
        method: "GET",
        headers: {
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
    // return DampData;
};

export interface CustomerHistoryQuery {
    page?: number;
    /** Server default is 100; the dialog asks for 200 per page. */
    limit?: number;
    toCart?: boolean;
    orderExist?: boolean;
    minDate?: string;
    maxDate?: string;
}

/** One page of a customer's uploads: `{result[], page, perPage, totalCount}` (newest first). */
export const getFullCustomerHistory = async (customerId: string | number, query: CustomerHistoryQuery = {}) => {
    const res = await apiFetch(`${API_URL}/mockup/events?${stringifyAnalytics3dParameters({ customerId, ...query })}`,{
        method: "GET",
        headers: {
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
    // return DampData;
};

export const getProductsList = async (limit = 2000) => {
    const res = await apiFetch(`${API_URL}/mockup/products?limit=${limit}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getUrlPathsList = async (limit = 2000) => {
    const res = await apiFetch(`${API_URL}/mockup/urlpaths?limit=${limit}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const customerUpdate = async ({data,  onSuccess}) => {
    const res = await apiFetch(`${API_URL}/mockup/customers/${data.customerId}/block`,{
        method: "POST",
        // mode: "no-cors", // no-cors, *cors, same-origin
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
            // 'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({isBlocked: data.isBlocked})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    const rest = await res.json();
    if (onSuccess) {
        onSuccess(rest);
    }
    return rest;
};

export const getRemovebgLogs = async (queryParams) => {
    const params = stringifyAnalytics3dParameters(queryParams);
    const res = await apiFetch(`${API_URL}/mockup/rembg-logs?${params}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getModelFrontLogById = async (logId: number) => {
    const res = await apiFetch(`${API_URL}/aav/model-front-logs/${logId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        if (res.status === 404) throw new Error('Log not found');
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getModelFrontLogs = async (queryParams) => {
    const params: string[] = [];
    if (queryParams.page) params.push(`page=${queryParams.page}`);
    if (queryParams.limit) params.push(`limit=${queryParams.limit}`);
    if (queryParams.sortDirection) params.push(`sortDirection=${queryParams.sortDirection}`);
    const res = await apiFetch(`${API_URL}/aav/model-front-logs?${params.join('&')}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const runMockupRecognition = async ({ createdAt_min, createdAt_max }) => {
    const res = await apiFetch(`${API_URL}/mockup/action/recognition`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            createdAt_min,
            createdAt_max
        })
    });
    if (!res.ok) {
        let message = 'Server Error!';
        try {
            const errorBody = await res.json();
            if (errorBody?.message) {
                message = errorBody.message;
            }
        } catch (error) {
            console.warn('Failed to parse recognition error response', error);
        }
        throw new Error(message);
    }
    return await res.json();
};

const dumpData = {
    "recognitionStats": {
        "totalCount": 819539,
        "recognizedCount": 92,
        "recognizedPercent": "0.01",
        "unrecognizedCount": "11",
        "unrecognizedPercent": "0.00",
        "errorCount": "819447",
        "errorCountPercent": "99.99"
    },
    "tagStats": {
        "totalRecognizedEvents": 92,
        "tags": [
            {
                "tagId": 50,
                "tagName": "single",
                "eventsCount": 75,
                "eventsToCart": "16",
                "eventsOrdered": "3",
                "eventsPercent": "81.52",
                "addToCartPercent": "21.33",
                "orderConversionPercent": "4.00"
            },
            {
                "tagId": 51,
                "tagName": "animal",
                "eventsCount": 39,
                "eventsToCart": "10",
                "eventsOrdered": "1",
                "eventsPercent": "42.39",
                "addToCartPercent": "25.64",
                "orderConversionPercent": "2.56"
            }
        ]
    }
}



